var $1df6722c6f19728b$exports = {};
$1df6722c6f19728b$exports = {
    "removeButtonLabel": `Ukloni`,
    "removeDescription": `Pritisnite Delete za uklanjanje oznake.`
};


export {$1df6722c6f19728b$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
